export default __webpack_public_path__ + "33844c2a757d98726b072c6d64d36ba2.svg";